import { useSnackbar } from 'notistack';
import { ConfirmDialog } from 'components';
import apiService from 'library/api-service';
import { FormattedMessage } from 'react-intl';
import { Dispatch, SetStateAction, useState } from 'react';
import { GridRowId, GridRowSelectionModel } from '@mui/x-data-grid-premium';

type DeleteEffortStatusContactDialogProps = {
  open: boolean;
  effortStatusContactId: GridRowId;
  handleClose: () => void;
  refresh: () => Promise<void>;
  setRowSelectionModel: Dispatch<SetStateAction<GridRowSelectionModel>>;
};

const DeleteEffortStatusContactDialog = ({
  open,
  effortStatusContactId,
  handleClose,
  refresh,
  setRowSelectionModel,
}: DeleteEffortStatusContactDialogProps) => {
  // other hooks
  const { enqueueSnackbar } = useSnackbar();

  // useState hooks
  const [loading, setLoading] = useState(false);

  // async helper functions
  const handleDelete = async () => {
    try {
      setLoading(true);

      const response = await apiService.deleteEffortStatusContact(Number(effortStatusContactId));

      if (response.isSuccess) {
        enqueueSnackbar(
          <FormattedMessage
            id="effortStatusContacts.deleteEffortStatusContactCompleted"
            defaultMessage="Seçili Efor Statü Muhatabını silme işlemi başarıyla tamamlandı."
          />,
          { variant: 'success' }
        );
        handleClose();
        setRowSelectionModel([]);
        refresh();
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmDialog
      open={open}
      title={
        <FormattedMessage
          id="effortStatusContacts.deleteEffortStatusContact"
          defaultMessage="Efor Statü Muhatabı Sil"
        />
      }
      description={
        <FormattedMessage
          id="effortStatusContacts.deleteEffortStatusContactRepeat"
          defaultMessage="Bu işlem onaylandıktan sonra Efor Statü Muhatabı veritabanından silinecektir. Silme işlemini onaylıyor musunuz?"
        />
      }
      onClose={handleClose}
      onConfirm={handleDelete}
      loading={loading}
      mobileFullScreen={false}
    />
  );
};

export default DeleteEffortStatusContactDialog;
